<template>
  <div class="block md:flex justify-start mb-0 md:mb-8 items-center">
    <Avatar v-model="avatar" />
    <div class="flex flex-col ml-2 text-center md:text-left">
      <span>{{ `${dataUser.name} ${dataUser.lastname}` }}</span>
      <span>{{ dataUser.roleName }}</span>
      <span class="cursor-pointer text-primary" @click="resetPass()">{{$t(`PROFILEVIEW.changePassword`)}}</span>
    </div>
  </div>
</template>

<script>
import Api from "@/helpers/api";
import Avatar from "./avatar.vue";
import { loading, closeLoding } from "@/helpers/$vs.js";
export default {
  components: { Avatar },
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    email: {
      type: String,
      required: true
    },
    dataUser: {
      type: Object,
      required: true
    }
  },
  methods: {
    async resetPass() {
      if (!this.matchPassword) {
        try {
          loading("default", "#profile");
          this.link_reset_pass = "";
          const data = {
            email: this.email,
            client_secret: "2sCl4nghzihZ93vVJiQD",
            action: "link"
          };
          const result = await Api.post(`/auth/resetpassword`, data);
          window.open(result.data.link);
        } catch (error) {
          console.log("Error profile: resetPass ", error);
        } finally {
          closeLoding("profile");
        }
      }
    }
  },
  computed: {
    avatar: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    set(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
